const MyDiscoveriesConstants = {
  ALL_DISCOVERIES: "All Discoveries"
};

export default MyDiscoveriesConstants;
